// extracted by mini-css-extract-plugin
export default {"formField":"Ioa-z","error":"Joa-z","disabled":"Koa-z","fieldError":"Loa-z","errorText":"Moa-z","button":"Noa-z","acknowledgment":"Ooa-z"};